import { cn } from "@/lib/utils";
import { PageLoader, CardLoader } from "./luxury-loader";

interface ContentFallbackProps {
  type?: 'page' | 'section' | 'card';
  count?: number;
  className?: string;
}

export function ContentFallback({ type = 'section', count = 1, className }: ContentFallbackProps) {
  if (type === 'page') {
    return (
      <div
        className={cn(
          "fixed inset-0 z-50 flex items-center justify-center",
          className
        )}
        style={{ background: "hsl(var(--bg-app))" }}
      >
        <PageLoader message="Preparing your luxury experience..." />
      </div>
    );
  }

  if (type === 'card') {
    return (
      <div className={cn("space-y-4", className)}>
        {Array.from({ length: count }).map((_, i) => (
          <CardLoader key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className={cn("space-y-4", className)}>
      <CardLoader />
    </div>
  );
}
